/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#reports-container[_ngcontent-%COMP%]{margin:30px 0 0!important}#reports-container[_ngcontent-%COMP%]   .select-info[_ngcontent-%COMP%]{color:#fb5050}.message[_ngcontent-%COMP%]{height:50px}.messageContent[_ngcontent-%COMP%]{color:#0f7bb6!important;padding:10px;border:1px solid #ccc;-webkit-box-shadow:3px 3px 2px #ccc;box-shadow:3px 3px 2px #ccc;-webkit-transition:.5s;transition:.5s}span.fa.fa-calendar.calendar-icon[_ngcontent-%COMP%]{position:absolute;top:10px;right:20px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/less/reports.component.less.shim.ngstyle.js.pre-build-optimizer.js